import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PesquisaComponent, PesquisaTouchComponent, MapaComponent}    from './lib/component';

const routes: Routes = [
//   { path: 'hero/:id', component: LoginComponent },
  { path: '', redirectTo: '/pesquisa', pathMatch: 'full' },
  { path: 'pesquisa', component: PesquisaComponent },
  { path: 'pesquisa-touch', component: PesquisaTouchComponent },
  { path: 'mapa', component: MapaComponent },
  //{ path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}


// export const appRoutingProviders: any[] = [

// ];

// export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/app.routing.ts
 **/